var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOCUSED MODE MEDIA MODALS BOOK AND ACTIVITY SIZE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4615 -1616C-4615 -1617.1 -4614.1 -1618 -4613 -1618H4782C4783.1 -1618 4784 -1617.1 4784 -1616V1163C4784 1164.1 4783.1 1165 4782 1165H-4613C-4614.1 1165 -4615 1164.1 -4615 1163V-1616Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4613 -1617H4782V-1619H-4613V-1617ZM4783 -1616V1163H4785V-1616H4783ZM4782 1164H-4613V1166H4782V1164ZM-4614 1163V-1616H-4616V1163H-4614ZM-4613 1164C-4613.55 1164 -4614 1163.55 -4614 1163H-4616C-4616 1164.66 -4614.66 1166 -4613 1166V1164ZM4783 1163C4783 1163.55 4782.55 1164 4782 1164V1166C4783.66 1166 4785 1164.66 4785 1163H4783ZM4782 -1617C4782.55 -1617 4783 -1616.55 4783 -1616H4785C4785 -1617.66 4783.66 -1619 4782 -1619V-1617ZM-4613 -1619C-4614.66 -1619 -4616 -1617.66 -4616 -1616H-4614C-4614 -1616.55 -4613.55 -1617 -4613 -1617V-1619Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "student focused mode with image preview open in activity - horizontally longer",
    clipPath: "url(#clip0_6444_16538)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    transform: "translate(-792 -96)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "activity completetion mode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_6444_16538",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-72 -16C-72 -20.4183 -68.4183 -24 -64 -24H936V1021H-72V-16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-72 -16C-72 -20.4183 -68.4183 -24 -64 -24H936V1021H-72V-16Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73 -16C-73 -20.9706 -68.9706 -25 -64 -25H936V-23H-64C-67.866 -23 -71 -19.866 -71 -16H-73ZM936 1021H-72H936ZM-73 1021V-16C-73 -20.9706 -68.9706 -25 -64 -25V-23C-67.866 -23 -71 -19.866 -71 -16V1021H-73ZM936 -24V1021V-24Z",
    fill: "#9D9690",
    mask: "url(#path-3-inside-1_6444_16538)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "student view activity states"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6444_16538)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: 22,
    width: 856,
    height: 919,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -31.5,
    y: 22.5,
    width: 855,
    height: 918,
    rx: 3.5,
    stroke: "#9D9690",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1187"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 650",
    x: -32,
    y: -4,
    width: 208,
    height: 6,
    rx: 3,
    fill: "#49ABAB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "centerfold video view"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 570",
    x: -32,
    y: -24,
    width: 856,
    height: 1045,
    rx: 4,
    fill: "#2E2E2D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1798"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -4,
    width: 154,
    height: 32,
    rx: 4,
    fill: "#2E2E2D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 16V12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 8H12.01",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6444_16538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "white",
    transform: "translate(-792 -96)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6444_16538"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: 22,
    width: 856,
    height: 919,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2da8a4bdfe673f204d27d8b80a2414a3.svg";
export { ForwardRef as ReactComponent };